var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":_vm.color,"textColor":_vm.textColor,"small":""}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.ip.ip))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }